// apps/web/app/microgrid/lit/components/WhyChoose.tsx
'use client';
import React, { useEffect, useRef } from 'react';
import { sectionViewOnce } from '../components/ga'
import './styles/WhyChoose.css';

const WhyChoose: React.FC = () => {
  const ref = useRef<HTMLElement | null>(null);
  useEffect(() => ref.current ? sectionViewOnce(ref.current, 'why_choose') : undefined, []);
  return (
    <section id="why" className="why" ref={ref}>
      <h2>Why Choose Always Lit?</h2>
      <p className="subtitle">The brightest products, the best service.</p>
      <div className="features">
        <div className="feature-card">
          <h3>Top-Tier Products</h3>
          <p>We install only industry-leading permanent lighting systems that look amazing and last.</p>
        </div>
        <div className="feature-card">
          <h3>Expert Installation</h3>
          <p>Licensed, insured technicians deliver flawless, professional installs—guaranteed.</p>
        </div>
        <div className="feature-card">
          <h3>Smart Control</h3>
          <p>Control millions of colors and schedules from an easy-to-use app.</p>
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;
